/* eslint-disable */
import http from 'common-module/src/util/http';

/**
 * @return {Promise<*>}
 */
export const queryCurrentVersion = async (data) => {
  return http.post('/mng/version/query-ws-version', data, {
    showError: false
  });
};

/**
 * @return {Promise<*>}
 */
export const querySendRecord = async (data) => {
  return http.post('/mng/version/send-record', data, {
    showError: false
  });
};

